import { render } from "./Bidding.vue?vue&type=template&id=5fa7e5de"
import script from "./Bidding.vue?vue&type=script&lang=js"
export * from "./Bidding.vue?vue&type=script&lang=js"
script.render = render

export default script